import React from 'react';
import { Link } from 'react-router-dom';
import Colors from '../styles/colors';
const { mainOrange } = Colors;

const SoundcastsTabs = props => {
  const { active, isFree, showAlertModal } = props;
  return (
    <div>
      <div className="padding-bottom-20px" style={{ display: 'flex', alignItems: 'center' }}>
        <span className="title-medium ">Soundcasts</span>
      </div>
      <ul className="nav nav-pills">
        <li role="presentation" className={active === 'individuals' ? 'active' : ''}>
          <Link
            to="/dashboard/soundcasts"
            style={{ backgroundColor: active === 'individuals' ? 'transparent' : '' }}>
            <span style={{ ...styles.link, color: active === 'individuals' ? mainOrange : '' }}>
              Individuals
            </span>
          </Link>
        </li>
        <li role="presentation" className={active === 'bundles' ? 'active' : ''}>
          {isFree ? (
            <a
              onClick={() =>
                showAlertModal({
                  title: 'Upgrade Required',
                  content: `Please upgrade to create soundcast bundles`,
                  upgrade: true,
                })
              }
              style={{ backgroundColor: 'transparent' }}>
              <span style={{ ...styles.link, color: active === 'bundles' ? mainOrange : '' }}>
                Bundles
              </span>
            </a>
          ) : (
            <Link
              to="/dashboard/soundcasts/bundles"
              style={{ backgroundColor: active === 'bundles' ? 'transparent' : '' }}>
              <span style={{ ...styles.link, color: active === 'bundles' ? mainOrange : '' }}>
                Bundles
              </span>
            </Link>
          )}
        </li>
        <li role="presentation" className={active === 'conversions' ? 'active' : ''}>
          {isFree ? (
            <a
              onClick={() =>
                showAlertModal({
                  title: 'Upgrade Required',
                  content: `Please upgrade to convert new soundcasts`,
                  upgrade: true,
                })
              }
              style={{ backgroundColor: 'transparent' }}>
              <span style={{ ...styles.link, color: active === 'conversions' ? mainOrange : '' }}>
                Conversions
              </span>
            </a>
          ) : (
            <Link
              to="/dashboard/soundcasts/conversions"
              style={{ backgroundColor: active === 'conversions' ? 'transparent' : '' }}>
              <span style={{ ...styles.link, color: active === 'conversions' ? mainOrange : '' }}>
                Conversions
              </span>
            </Link>
          )}
        </li>
      </ul>
    </div>
  );
};

const styles = {
  link: {
    fontSize: 15,
    fontWeight: 600,
  },
};

export default SoundcastsTabs;
